<template>
  <Popup :header="''" @accept="acceptAndClose()" @abort="closePopup()">
    <template v-slot:content>

      <div class="passwortAendern">
        <v-row>
          <h2>Passwort ändern</h2>
        </v-row>
        <v-form ref="passwortAendernForm">
          <v-row>
            <v-col>
              <b-text-field
                  label="Passwort"
                  type="password"
                  v-model="password"
                  placeholder=" "
                  hint="Passwortrichtlinien: Das Passwort muss mindestens 8 Zeichen lang sein und mind. drei Zeichenarten (Kleinbuchstaben, Großbuchstaben, Zahlen, Sonderzeichen) enthalten."
                  :rules="[
                    validations.required,
                    validations.passwordValidation
                  ]"
              />
            </v-col>
            <v-col>
              <b-text-field
                  label="Passwort wiederholen"
                  type="password"
                  v-model="passwordConfirm"
                  placeholder=" "
                  :rules="[
                    validations.wiederholungValidation('Passwörter', password, passwordConfirm)
                  ]"
              />
            </v-col>
          </v-row>
        </v-form>
        <v-snackbar v-model="showSnackbar" timeout="4000" color="red">
          {{ snackbarText }}
        </v-snackbar>
      </div>

    </template>
    <template v-slot:accept-btn-label> Passwort Ändern </template>
  </Popup>
</template>

<script>
import Popup from '@/components/base_components/Popup';
import axios from "axios";
import validations from "@/service/validations";

export default {
  name: 'PasswortAendernPopup',
  components: { Popup },
  props: {
    username: {
      type: String,
      required: true
    },
    profil: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      password: null,
      passwordConfirm: null,
      validations: validations,
    };
  },
  computed: {},
  methods: {
    closePopup() {
      this.$emit('close');
    },
    acceptAndClose() {
      const userData = {
        username: this.username,
        password: this.password
      };
      if (this.$refs.passwortAendernForm.validate()) {
        if (this.profil) {
          axios
            .put('/v1/auth/updatepassword', userData)
            .then(() => {
              this.$emit('save');
              this.closePopup();
            })
            .catch((error) => {
              if (error.response.message && error.response.message !== '') {
                this.snackbarText = error.response.message;
              } else {
                this.snackbarText = 'Ändern des Passworts fehlgeschlagen. Bitte überprüfen Sie ihre Eingabe-Daten';
              }
              this.showSnackbar = true;
            });
        } else {
          axios
            .put('/v1/auth/admin/updatepassword', userData)
            .then(() => {
              this.$emit('save');
              this.closePopup();
            })
            .catch((error) => {
              if (error.response.message && error.response.message !== '') {
                this.snackbarText = error.response.message;
              } else {
                this.snackbarText = 'Ändern des Passworts fehlgeschlagen. Bitte überprüfen Sie ihre Eingabe-Daten';
              }
              this.showSnackbar = true;
            });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.passwortAendern {
  h2 {
    text-align: left;
    padding-left: 12px;
  }
}

</style>
